import { COMPANY, homeMeta, pages, type PageMeta } from './growth';
const origin = 'https://yummo.com.br';
const escape = (value: string) => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
export function structuredData(page: PageMeta) {
  const organization = {
    '@type': 'Organization', '@id': `${origin}/#organization`, name: 'Yummo', legalName: COMPANY.name,
    url: `${origin}/`, logo: `${origin}/logo.svg`, email: COMPANY.email, taxID: COMPANY.cnpj,
    address: { '@type': 'PostalAddress', addressLocality: 'São Paulo', addressRegion: 'SP', addressCountry: 'BR' },
  };
  const graph: Record<string, unknown>[] = [organization, {
    '@type': 'WebSite', '@id': `${origin}/#website`, url: `${origin}/`, name: 'Yummo', inLanguage: 'pt-BR', publisher: { '@id': `${origin}/#organization` },
  }, {
    '@type': page.path === '/contact' ? 'ContactPage' : page.path === '/about' ? 'AboutPage' : 'WebPage',
    '@id': `${origin}${page.path}#webpage`, url: `${origin}${page.path}`, name: page.title, description: page.description,
    inLanguage: 'pt-BR', isPartOf: { '@id': `${origin}/#website` },
  }];
  if (page.path !== '/' && !page.noindex) graph.push({
    '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Yummo', item: `${origin}/` },
      { '@type': 'ListItem', position: 2, name: page.label, item: `${origin}${page.path}` },
    ],
  });
  if (page.path === '/' || page.path === '/restaurant-management') graph.push({
    '@type': 'SoftwareApplication', '@id': `${origin}/#software`, name: 'Yummo', url: `${origin}/restaurant-management`,
    applicationCategory: 'BusinessApplication', operatingSystem: 'Web', inLanguage: 'pt-BR',
    description: 'Software gratuito para operar restaurantes. Serviços complementares podem ter condições próprias.',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'BRL', description: 'Uso do software para operar o restaurante, sem mensalidade.' },
    publisher: { '@id': `${origin}/#organization` },
  });
  return { '@context': 'https://schema.org', '@graph': graph };
}
export function renderDocument(html: string, page: PageMeta, markup: string) {
  return html
    .replace(/<!--app-start-->[\s\S]*?<!--app-end-->/, () => `<!--app-start--><div id="app">${markup}</div><!--app-end-->`)
    .replace(/<title>[\s\S]*?<\/title>/, () => `<title>${escape(page.title)}</title>`)
    .replace(/<meta\s+name="description"\s+content="[^"]*"\s*\/?>/, () => `<meta name="description" content="${escape(page.description)}">`)
    .replace(/<meta\s+property="og:title"\s+content="[^"]*"\s*\/?>/, () => `<meta property="og:title" content="${escape(page.title)}">`)
    .replace(/<meta\s+property="og:description"\s+content="[^"]*"\s*\/?>/, () => `<meta property="og:description" content="${escape(page.description)}">`)
    .replace(/<meta\s+property="og:url"\s+content="[^"]*"\s*\/?>/, () => `<meta property="og:url" content="${origin}${page.path}">`)
    .replace(/<link\s+rel="canonical"\s+href="[^"]*"\s*\/?>/, () => `<link rel="canonical" href="${origin}${page.path}">`)
    .replace(/<!--seo-start-->[\s\S]*?<!--seo-end-->/g, '')
    .replace('</head>', () => `<!--seo-start--><meta name="robots" content="${page.noindex ? 'noindex, follow' : 'index, follow'}"><meta name="twitter:card" content="summary_large_image"><meta name="twitter:title" content="${escape(page.title)}"><meta name="twitter:description" content="${escape(page.description)}"><meta name="twitter:image" content="${origin}/images/restaurant-hero.webp"><script id="site-schema" type="application/ld+json">${JSON.stringify(structuredData(page)).replace(/</g, '\\u003c')}</script><!--seo-end--></head>`);
}
export function installMetadata(page: PageMeta) {
  document.title = page.title;
  function meta(key: string, value: string, property = false) {
    const attribute = property ? 'property' : 'name';
    let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
    if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, key); document.head.append(element); }
    element.content = value;
  }
  meta('description', page.description);
  meta('robots', page.noindex ? 'noindex, follow' : 'index, follow');
  meta('og:title', page.title, true);
  meta('og:description', page.description, true);
  meta('og:url', origin + page.path, true);
  meta('twitter:card', 'summary_large_image');
  meta('twitter:title', page.title);
  meta('twitter:description', page.description);
  meta('twitter:image', origin + '/images/restaurant-hero.webp');
  const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (canonical) canonical.href = origin + page.path;
  let schema = document.querySelector<HTMLScriptElement>('#site-schema');
  if (!schema) { schema = document.createElement('script'); schema.id = 'site-schema'; schema.type = 'application/ld+json'; document.head.append(schema); }
  schema.textContent = JSON.stringify(structuredData(page));
}
export function sitemap() {
  return `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n${[homeMeta, ...pages].filter(p => !p.noindex).map(p => `  <url><loc>${origin}${p.path}</loc></url>`).join('\n')}\n</urlset>\n`;
}
